import cx from "classnames"
import * as React from "react"
import * as styles from "./styles.module.scss"
import { useEffect, useRef } from "react"

export interface TilterProps {
  className?: string
  children: React.ReactNode
  quantity?: TilterQuantity
}

export enum TilterQuantity {
  Medium = "medium",
  Small = "small",
}

/*
On mouse hover tiles in "Learn More About Mortgages", tiltes them based on cursor
position
*/

const Tilter: React.FC<TilterProps> = ({
  children,
  quantity = TilterQuantity.Medium,
}) => {
  const element = useRef<HTMLDivElement>(null)

  useEffect(() => {
    mouseMoveEvent()
    mouseLeaveEvent()
    return () => {}
  }, [])

  const mouseMoveEvent = (): void => {
    element.current?.addEventListener("mousemove", (event) => {
      if (element.current) {
        const rect = element.current.getBoundingClientRect()
        // Get position of mouse within the element in +/- 5
        const positionX = (
          ((event.clientX - rect.left) / rect.width) * 10 -
          5
        ).toFixed(2)
        const positionY = (
          ((event.clientY - rect.top) / rect.height) * 10 -
          5
        ).toFixed(2)
        element.current.style.transform = `rotateX(${
          Number(positionY) * -1
        }deg) rotateY(${positionX}deg)`
      }
    })
  }

  const mouseLeaveEvent = (): void => {
    element.current?.addEventListener("mouseleave", () => {
      if (element.current) {
        return (element.current.style.transform = "rotateX(0deg) rotateY(0deg)")
      }
    })
  }

  return (
    <div
      ref={element}
      className={cx({
        [styles.medium]: quantity = TilterQuantity.Medium,
        [styles.small]: quantity = TilterQuantity.Small,
      })}
    >
      <div className={styles.tilted}>{children}</div>
    </div>
  )
}

export default Tilter
